import { NavigationItemModel } from '@stories/Widgets/Header/Header.types';
import * as React from 'react';
import { idMatchesActiveItemId } from '../../../Header,helpers';
import DesktopNavigationDropdownLink from '../../DesktopNavigationDropdownLink/DesktopNavigationDropdownLink';
import S from '../ProductDropdown.styles';

export type VariantBProps = {
  levels: (NavigationItemModel[] | undefined)[][];
  activeItemId: string | null;
  translations: Record<string, string>;
};

const VariantB: React.FC<VariantBProps> = ({ levels, activeItemId, translations }) => {
  return (
    <S.Column>
      {levels.flat().map(
        (level) =>
          level &&
          level.map((item) => {
            const visibleColumnCount = level.filter((x) => idMatchesActiveItemId(x.id, activeItemId)).length;

            return (
              <li key={item.id}>
                <S.Column
                  data-visible={idMatchesActiveItemId(item.id, activeItemId)}
                  data-force-four-columns={visibleColumnCount <= 4}
                  data-force-five-columns={visibleColumnCount <= 5}
                  data-split-columns={item.children && item.children.length >= 22}
                >
                  <DesktopNavigationDropdownLink
                    key={item.id}
                    item={item}
                    visible={idMatchesActiveItemId(item.id, activeItemId)}
                    dropdownLevel="2"
                    translations={translations}
                  />
                  {item.children &&
                    item.children.map((item) => (
                      <DesktopNavigationDropdownLink
                        key={item.id}
                        item={item}
                        visible={idMatchesActiveItemId(item.id, activeItemId)}
                        dropdownLevel="3"
                        translations={translations}
                      />
                    ))}
                </S.Column>
              </li>
            );
          }),
      )}
    </S.Column>
  );
};

export default VariantB;
